import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { InputText } from "../inputs/text-input";
import { Checkbox } from "../inputs/checkbox";
import Cookies from 'js-cookie';
import Buttons from "../buttons/button-primary";
import ButtonsSecondary from "../buttons/button-secondary";
import OtpInputNumber from "../inputs/otp-input";
import InputNumber from "../inputs/number-input";
import validateMobile from "./registerEditMobileNumberValidation";
import { registerResendOtp } from "../../redux/actions/registrationResendOtp";
import { registerEditMobile } from "../../redux/actions/registrationEditMobileNumber";
import axios from 'axios';
import API from '../../API';
import { clearRegisterOtpError } from '../../redux/actions/register-otp';
import { clearRegisterResendOtpMessages } from '../../redux/actions/registrationResendOtp';
import { logoutCookie } from '../../utils';
// registerPersonal
const LoginOTP = (props) => {
    const [isOpen, openModal] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const personal = useSelector(state => state.registerOtp.registration);
    const personalLoading = useSelector(state => state.registerOtp.loading);
    const personalError = useSelector(state => state.registerOtp.error);
    const registerPersonal = useSelector(state => state.registerPersonal.registration);
    const resendOtpLoading = useSelector(state => state.registerResendOtp.loading);
    const resendOtpError = useSelector(state => state.registerResendOtp.error);
    const resendOtpSuccess = useSelector(state => state.registerResendOtp.success);
    
    const handleBackToLogin = () => {
        logoutCookie(); // Clear cookies and localStorage
        history.push('/login');
    };
    
    const toggleModal = () => {
        if (!isOpen) {
            // Clear errors when opening modal
            setState((prevProps) => ({
                ...prevProps,
                changedMobileNumberError: "",
                isUpdatingMobile: false,
            }));
        }
        openModal(!isOpen);
    };
    const [state, setState] = useState({
        mobileNumber: Cookies.get('mobileNumber'),
        otp: "",
        otpError: "",
        mobileNumberError: "",
        changedMobileNumber: "",
        changedMobileNumberError: "",
        isUpdatingMobile: false,
    })
    
    const handleChange = (data) => {
        setState((prevProps) => ({
            ...prevProps,
            otp: data,
            otpError: "", // Clear error when user types
        }))
    }

    const validateOtp = (otp) => {
        if (!otp || otp.trim() === "") {
            return "Please enter the OTP";
        }
        if (otp.length !== 6) {
            return "Please enter a complete 6-digit OTP";
        }
        if (!/^\d{6}$/.test(otp)) {
            return "OTP should contain only numbers";
        }
        return "";
    }

    const handleOtpVerification = () => {
        const otpError = validateOtp(state.otp);
        
        if (otpError) {
            setState((prevProps) => ({
                ...prevProps,
                otpError: otpError,
            }));
            return;
        }

        // Clear any existing error and success messages
        setState((prevProps) => ({
            ...prevProps,
            otpError: "",
        }));
        
        // Clear success and error messages when user clicks verify
        dispatch(clearRegisterResendOtpMessages());
        dispatch(clearRegisterOtpError());

        // Proceed with verification
        props.handeleOtpVerification(state.otp, registerPersonal.data.confirmation_token);
    }
    const handleResendOtp = (confirmation_token) => {
        dispatch(clearRegisterResendOtpMessages());
        dispatch(clearRegisterOtpError());
        dispatch(registerResendOtp(confirmation_token));
        
        // Clear the OTP input field when resending
        setState((prevProps) => ({
            ...prevProps,
            otp: "",
            otpError: "",
        }));
        
        const email = registerPersonal?.data?.email || registerPersonal?.email;

        // Call test API to get the OTP for debugging
        axios.get(`${API.baseURL}/get_user_details?mobile_number=${email}`, API.options)
            .then((response) => {
                console.log('User details response:', response.data);
                // You can also access the OTP here, e.g., response.data.otp
            })
            .catch((error) => {
                console.error('Error fetching user details:', error);
            });
    };
    const numberUpdate = (event) => {
        event.preventDefault()
        const errors = validateMobile(state)
        const data = {
            user_id: registerPersonal.data.user_id,
            mobile_number: state.changedMobileNumber
        }
        
        if(!errors.valid){
            setState((prevProps) => ({
                ...prevProps,
                changedMobileNumberError: errors.changedMobileNumberError,
            }));
            return;
        }
        
        // Set loading state
        setState((prevProps) => ({
            ...prevProps,
            isUpdatingMobile: true,
            changedMobileNumberError: "",
        }));
        
        axios.put(API.baseURL + "/providers/update_mobile_number_without_login ", data, API.options)
            .then(response => response.data)
            .then((result) => {
                setState((prevProps) => ({
                    ...prevProps,
                    mobileNumber: state.changedMobileNumber,
                    isUpdatingMobile: false,
                    changedMobileNumberError: "",
                }));
                
                // Call getUserDetails API after successful mobile number update
                const email = registerPersonal?.data?.email || registerPersonal?.email;
                if (email) {
                    axios.get(`${API.baseURL}/get_user_details?mobile_number=${email}`, API.options)
                        .then((response) => {
                            console.log('User details response after mobile update:', response.data);
                            // You can also access the OTP here, e.g., response.data.otp
                        })
                        .catch((error) => {
                            console.error('Error fetching user details after mobile update:', error);
                        });
                }
                
                // Close modal only on success
                toggleModal();
            })
            .catch(error => {
                console.error('Mobile update error:', error);
                const errorMessage = error.response?.data?.data?.message || error.response?.data?.message || "Failed to update mobile number";
                setState((prevProps) => ({
                    ...prevProps,
                    isUpdatingMobile: false,
                    changedMobileNumberError: errorMessage,
                }));
            });
    }
    const handleMobileChange = (event) => {
        const value = event.target.value;
        // Only allow up to 10 digits
        if (value.length <= 10) {
            setState((prevProps) => ({
                ...prevProps,
                changedMobileNumber: value,
                changedMobileNumberError: "",
            }));
        }
    }

    useEffect(() => {
        dispatch(clearRegisterOtpError());
        dispatch(clearRegisterResendOtpMessages());
        
        // Call getUserDetails API when page loads
        const email = registerPersonal?.data?.email || registerPersonal?.email;
        if (email) {
            axios.get(`${API.baseURL}/get_user_details?mobile_number=${email}`, API.options)
                .then((response) => {
                    console.log('User details response on page load:', response.data);
                    // You can also access the OTP here, e.g., response.data.otp
                })
                .catch((error) => {
                    console.error('Error fetching user details on page load:', error);
                });
        }
    }, [dispatch, registerPersonal]);

    return (
        <>
            <Row form>
                <Col sm="12">
                    <div className="position-relative mt-3">
                        <InputText
                            disabled={true}
                            label="Mobile Number"
                            value={state.mobileNumber}
                            name="login_number"
                            id="login_number"
                        />
                        <div className="ebw-input__option-edit position-absolute" onClick={() => toggleModal()}>Edit</div>
                    </div>

                    <div className="d-flex flex-row justify-content-end align-items-center  ml-2 ml-md-4 mr-2">
                        <div onClick={() => !resendOtpLoading && handleResendOtp(registerPersonal.data.confirmation_token)} className="ebw-entry__tab-forgot">
                            <a className="mb-0 text-sm ebw-entry__tab-forgot--link" role="button" href="#" style={{opacity: resendOtpLoading ? 0.6 : 1, pointerEvents: resendOtpLoading ? 'none' : 'auto'}}>
                                {resendOtpLoading ? 'Sending...' : 'Resend OTP'}
                            </a>
                        </div>
                    </div>
                </Col>
            </Row>
            <Form>
                <Row form>
                    <Col sm="12">
                        <OtpInputNumber
                            value={state.otp}
                            changeEvent={handleChange}
                            otpError={state.otpError}
                        />
                        {personalError ? <div className="ebw-error mt-2" style={{padding: '5px !important'}}>{personalError}</div> : ""}
                        {resendOtpSuccess ? <div className="ebw-success mt-2" style={{padding: '10px', background: '#d4edda', color: '#155724', border: '1px solid #c3e6cb', borderRadius: '5px'}}>{resendOtpSuccess}</div> : ""}
                        {resendOtpError ? <div className="ebw-error mt-2" style={{padding: '5px !important'}}>{resendOtpError}</div> : ""}
                    </Col>

                    <Col sm="12" className="mt-5">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <ButtonsSecondary clickEvent={handleBackToLogin} type="button" text="Back to Login" />
                            </div>
                            <div>
                                <Buttons clickEvent={handleOtpVerification} type="button" text={props.buttonName} />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Form>
            <div className="ebw-profile__modal">
                <div className="px-5 py-5">
                    <Modal isOpen={isOpen}>
                        <div className="px-5 py-5 ebw-modal__wrap">
                            <ModalHeader toggle={toggleModal} className="ebw-profile__modal-head mb-4" style={{ border: "none" }}>
                                <div className="ebw-modal__title mb-1">Edit mobile number </div>
                                <div className="ebw-modal__para">We will send you an access code via mobile for verification.</div>
                            </ModalHeader>

                            <ModalBody className="ebw-modal__body">
                                <form className="ebw-modal__form">
                                    <div className="ebw-modal__input-wrap mb-2">
                                        <InputNumber
                                            changeEvent={(e) => handleMobileChange(e)}
                                            value={state.changedMobileNumber}
                                            className="ebw-modal__input" type="number"
                                            placeholder="Enter new mobile number"
                                            error=""
                                            required
                                            maxLength={10}
                                        />
                                    </div>
                                    {state.changedMobileNumberError && (
                                        <div style={{color: 'red', marginTop: -5, marginBottom: 10}}>
                                            {state.changedMobileNumberError}
                                        </div>
                                    )}
                                    <div className="text-right">
                                        <button
                                            onClick={(e) => numberUpdate(e)}
                                            className="ebw-modal__submit ebw-button__primary"
                                            type="submit"
                                            disabled={state.isUpdatingMobile}
                                            style={{opacity: state.isUpdatingMobile ? 0.6 : 1, pointerEvents: state.isUpdatingMobile ? 'none' : 'auto'}}>
                                            {state.isUpdatingMobile ? 'Updating...' : 'Verify'}
                                        </button>
                                    </div>
                                </form>
                            </ModalBody>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    );
}

export default LoginOTP;